"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var _default = /*#__PURE__*/_react["default"].createElement("svg", {
  width: "16",
  height: "14",
  viewBox: "0 0 16 14"
}, /*#__PURE__*/_react["default"].createElement("path", {
  d: "M12.95 11.06a1 1 0 01.28-.47A5.2 5.2 0 0015 6.76C15 3.73 12.03 1 8 1 3.97 1 1 3.73 1 6.76c0 3.1 3.03 6.04 6.93 5.77a5.2 5.2 0 001.08-.22c.19-.05.38-.11.58-.12.38-.02.8.13 1.18.27l.36.13a190.99 190.99 0 011.27.41l.55-1.94zm.96.26l-.54 1.96a1 1 0 01-1.27.67c-.2-.06-2.36-.77-2.46-.76l-.27.06c-.33.1-.9.25-1.37.28-4.4.3-8-3.03-8-6.77C0 3.03 3.58 0 8 0s8 3.03 8 6.76a6.2 6.2 0 01-2.09 4.56zM4.2 5.5c0-.28.22-.5.5-.5h6.82a.5.5 0 010 1H4.7a.5.5 0 01-.5-.5zM4.7 8a.5.5 0 100 1h6.82a.5.5 0 100-1H4.7z"
}));

exports["default"] = _default;